











import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api";
import { debounce } from "lodash-es";
import { ContentSet, InputContentSetUpdate } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import BaseButton from "@/components/BaseButton";
import HashtagsSetupView from "../HashtagsSetupView";

export default defineComponent({
  name: "PostHashtagsSettings",
  components: { HashtagsSetupView, BaseButton },
  props: {
    postData: { type: Object as PropType<ContentSet>, required: true },
  },
  setup(props, { emit }) {
    const selectedTags = ref<TagInfo[]>(props.postData.tags);
    const selectedIds = computed<string[]>(() => selectedTags.value.map(t => t.id));

    const toggleTag = (tag: TagInfo, value: boolean) => {
      if (value) {
        selectedTags.value.push(tag);
      } else {
        selectedTags.value = selectedTags.value.filter(t => t.id !== tag.id);
      }
    };

    const onReset = () => {
      selectedTags.value = [];
    };

    watch(
      selectedTags,
      debounce(() => {
        const data: Omit<InputContentSetUpdate, "id"> = {
          tagIds: selectedIds.value,
        };
        emit("partialUpdate", { data, tags: selectedTags.value });
      }, 500)
    );

    return { selectedTags, selectedIds, onReset, toggleTag };
  },
});
